import * as React from "react";
import { Box } from "@mui/material";
import Proptypes from 'prop-types';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: Proptypes.element,
  value: Proptypes.number,
  index: Proptypes.number
}

export default TabPanel;
